<template>
    <div class="modal" tabindex="-1" v-if="visible" @before-open="beforeOpen">
        <div class="modal-dialog" >
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ $t('gameNotes.title') }}</h5>
                    <button type="button" class="btn-close" @click="cancel" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="mb-3">
                      <a :href='spectatorLink(game)' target="_blank">Spectator link</a><br/>
                      <textarea class="form-control" id="exampleFormControlTextarea1" rows="6" v-model="text"></textarea>

                      <div v-if="currentUser.notifications_enabled" class="form-check form-switch mt-3">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          id="gameNotificationsSwitch"
                          v-model="notificationsEnabled"
                        />
                        <label class="form-check-label" for="gameNotificationsSwitch">
                          {{ $t('gameNotes.enableNotifications') }}
                        </label>
                      </div>

                      <a :href='undefined' role="button" @click="toggleChat">Chat</a><br />
                      <Chat :game="game._id" :openChat="true" :position="'inline'"></Chat>
                  </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary btn-sm" @click="save">{{ $t('common.save') }}</button>
                    <button type="button" class="btn btn-secondary btn-sm" @click="cancel">{{ $t('common.cancel') }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import util from '../../util';
import Chat from '../chat/Chat';
import TMService from '../../services/tm.service';

export default {
  name: "GameNotes",
  components: { Chat },
  props: ["game", "visible"],
  emits: ["closeModal", "saveNotes"],
  data() {
    return {
        chatVisible: false,
        text: '',
        notificationsEnabled: false
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    }
  },
  methods:{
    save(){
        this.$emit('saveNotes', this.text);

        // Toggle notifications if changed
        if (this.notificationsEnabled !== this.game.notifications_enabled) {
          TMService.toggleGameNotifications(this.game._id);
        }
    },
    toggleChat(){
      this.chatVisible = !this.chatVisible;
    },
    cancel(){
      this.$emit('closeModal');
    },
    spectatorLink: util.spectatorLink
  },
  watch: {
    game: function() { // watch it
      this.text = this.game.notes;
      this.notificationsEnabled = !!this.game.notifications_enabled;
    }
  }
};
</script>

<style scoped>
  .modal {
    display: block;
  }
</style>